export default __webpack_public_path__ + "static/media/logo.a0709068.png";